import { useScreeningDescriptionText } from '../ScreeningShared'
import { useScreeningContinue } from '../useScreeningContinue'
import { ScreeningViewTemplate } from '../ScreeningTemplate'
import { useSelectFormattedScreeningHandledDate, useSelectFirstName } from '../../../../state/selectors'
import { ScreeningType } from '@estercare/ester-shared'
import { useTranslation } from 'react-i18next'
import { useGetUserHealthPlanOutcomesQuery } from '../../../../api/ester-b2b-api/private/healthPlan/healthPlanQueries'
import { Outcomes } from '../../../healthPlan/Outcomes'

export const ScreeningCheckInContinue = () => {
  const parentScreeningDate = useSelectFormattedScreeningHandledDate()
  const firstName = useSelectFirstName()
  const { t } = useTranslation()
  const { data: outcomesData } = useGetUserHealthPlanOutcomesQuery()

  const screeningDescription = useScreeningDescriptionText(ScreeningType.CHECK_IN, parentScreeningDate || '')
  const { onContinue, optInFields, isButtonDisabled, errorMsg } = useScreeningContinue('check_in_continue')
  return (
    <ScreeningViewTemplate
      pageTitle={t('employee.screening.checkInContinuePage')}
      screeningTitle={t('employee.screening.checkInTitle', { firstName })}
      screeningDescription={screeningDescription}
      leftAlignText
      screeningAdditionalChildren={optInFields}
      fullWidthChildren={
        outcomesData?.outcomes?.length ? (
          <Outcomes
            outcomes={outcomesData.outcomes}
            title={t('employee.screening.outcomesTitle', { date: parentScreeningDate })}
            description={t('employee.screening.outcomesDescription')}
          />
        ) : undefined
      }
      buttonText={t('employee.screening.checkInContinueButton')}
      onButtonClick={onContinue}
      isButtonDisabled={isButtonDisabled}
      errorMsg={errorMsg}
    />
  )
}
